var $hijax = {
  // ======================================================================
  // OPTIONS
  // ======================================================================

  preloadPages: true,
  retryLimit: 0,

  // ======================================================================
  // VARS
  // ======================================================================

  loadedPages: [], // pages that have already been loaded
  loadedPageLinks: [], // pages that have had linked pages loaded
  erroredPages: [], // pages that could not be loaded

  // ======================================================================
  // INTI
  // ======================================================================

  init: function() {
    if (typeof document.readyState !== 'undefined') {
      if (document.readyState === 'complete') {
        var links = $('body').find('a');
        $hijax.loadLinks(links);
      } else {
        setTimeout(function() {
          $hijax.init();
        }, 1000);
      }
    }
  },

  // ======================================================================
  // LOAD ALL PAGES LINKED FROM THE CURRENT PAGE
  // ======================================================================

  loadPageLinks: function() {
    var currentPage = $pages.currentPage;
    // check if page links have already been loaded
    if ($.inArray(currentPage, $hijax.loadedPageLinks) < 1) {
      // update array
      $hijax.loadedPageLinks.push(currentPage);
      // find all links on the page
      var links = $('#page-' + currentPage).find('a');
      $hijax.loadLinks(links);
    }
  },

  loadLinks: function(links) {
    if ($hijax.preloadPages) {
      links.each(function() {
        // check if link is to a page on the current site
        var path = $(this).attr('href');
        var isSiteLink = $hijax.isSiteLink(path);
        if (isSiteLink) {
          // load the page
          $hijax.loadPage(path);
        }
      });
    }
  },

  // ======================================================================
  // LOAD A PAGE
  // ======================================================================

  loadPage: function(path, callback, loop) {
    var pageId = $pages.pathToId(path);
    if (typeof loop === 'undefined') {
      loop = 0;
    }
    // check if page has already been loaded
    if ($.inArray(pageId, $hijax.loadedPages)) {
      // double check if page has been loaded
      var check = $('#page-' + pageId).length;
      if (check < 1) {
        // ajax the page
        $ajax({
          url: path,
          data: {
            ajax: true
          },
          callback: $hijax.loadPageCallback,
          callback_vars: {
            pageId: pageId,
            path: path,
            callback: callback,
            loop: loop
          },
          method: 'GET',
          dataType: 'html'
        });
      }
    }
  },
  loadPageCallback: function(response, vars) {
    var pageElement = '#page-' + vars.pageId;
    // check if page has already been loaded
    if ($.inArray(vars.pageId, $hijax.loadedPages) < 0) {
      var html = $(response).find(pageElement);
      var found = html.length == 1;
      // success
      if (found) {
        // title
        var title = 'Matter';
        $(response).each(function() {
          if ($(this).is('title')) {
            title = $(this)
              .html()
              .replace(/"/g, "'");
          }
        });
        html.attr('data-title', title);
        // update array
        $hijax.loadedPages.push(vars.pageId);
        // append new content
        $el('#wrapper').append(html);
        // reinit js
        $hijax.reInitAll();
        // callback
        if (typeof vars.callback === 'function') {
          vars.callback();
        }
      }
      // error - try again
      else if (vars.loop < $hijax.retryLimit) {
        console.log('ERROR LOADING PAGE - TRYING AGAIN', vars.path);
        setTimeout(function() {
          $hijax.loadPage(vars.path, vars.callback, vars.loop + 1);
        }, 1000);
      }
      // error - give up
      else {
        console.log('ERROR LOADING PAGE - GIVING UP', vars.path);
        // append error page
        var error = $el('#js-error-template').html();
        $el('#wrapper').append(
          '<main id="page-' + vars.pageId + '" data-title="404 Error" class="page">' + error + '</main>'
        );
        // reinit js
        $hijax.reInitAll();
        // callback
        if (typeof vars.callback === 'function') {
          vars.callback();
        }
      }
    } else {
      // callback
      if (typeof vars.callback === 'function') {
        vars.callback();
      }
    }
  },

  // ======================================================================
  // HELPERS
  // ======================================================================

  // check if a link is a page on the current site
  isSiteLink: function(link) {
    if (typeof link === 'undefined' || link.charAt(0) === '#') {
      return false;
    } else {
      link = link.replace('www.', '');
      var origin = window.location.origin.replace('www.', '');
      if (link.indexOf(origin) > -1 || (link.charAt(0) === '/' && link.indexOf('cdn-cgi') < 0)) {
        return true;
      } else {
        return false;
      }
    }
  },

  // reinit js stuff after loading a new page via AJAX
  reInitAll: function() {
    // scroll
    // animate
    $animate.reinitAfterAJAX();
    // utils
    $utils.reinitAfterAJAX();
    // windowsize
  }
};
